<template>
  <div class="writer_book_info">
    <div class="owner_title">写手书籍信息登记</div>
    <div class="btn_box">
      <div class="book_btn_box">
        <div class="book_btn" @click="ceaseCooperate()">
          <i class="iconfont icon-tingzhi"></i> 停止合作
        </div>
        <div class="book_btn" @click="weekOperate()">
          <i class="iconfont icon-zhuanhuan"></i> 转周结
        </div>
      </div>
      <div class="filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>
    <!-- 筛选表单 -->
    <div class="filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="金主编辑" prop="operator_name">
          <el-input v-model="filter_form.operator_name"></el-input>
        </el-form-item>
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="写手昵称" prop="writer_nickname">
          <el-input v-model="filter_form.writer_nickname"></el-input>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="filter_form.is_task" placeholder="任务状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="进行中" value="1"></el-option>
            <el-option label="已完结" value="2"></el-option>
            <el-option label="已停止" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日周结">
          <el-select v-model="filter_form.write_type" placeholder="日周结">
            <el-option label="全部" value=""></el-option>
            <el-option label="日结" value="1"></el-option>
            <el-option label="周结" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="filter_form.createtime"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="goSearch"
          >搜索</el-button
        >
      </el-form>
    </div>

    <!-- 表格数据 -->
    <el-table
      class="table_box"
      @selection-change="handleSelectionChange"
      tooltip-effect="dark"
      height="550"
      :data="dataShow"
      border
      style="width: 98%"
    >
      <el-table-column type="selection" width="40"></el-table-column>
      <el-table-column type="index" label="序号" align="center" width="50">
      </el-table-column>
      <el-table-column
        property="operator_name"
        label="金主编辑"
        align="center"
        sortable
        :width="equipmentType == 0 ? 250 : 101"
      >
      </el-table-column>
      <el-table-column
        property="connectionessay_name"
        label="书名"
        align="center"
        sortable
        :width="equipmentType == 0 ? 400 : 90"
      >
      </el-table-column>
      <el-table-column
        property="writer_nickname"
        label="写手昵称"
        align="center"
        sortable
        :width="equipmentType == 0 ? 200 : 101"
      >
      </el-table-column>
      <el-table-column
        property="writer_cost"
        label="给写手千字价格"
        align="center"
        sortable
        :width="equipmentType == 0 ? 200 : 150"
      >
      </el-table-column>
      <el-table-column
        property="each_chapter_num"
        label="每章字数"
        align="center"
        sortable
        :width="equipmentType == 0 ? 150 : 110"
      >
      </el-table-column>
      <el-table-column
        property="is_task"
        label="任务状态"
        align="center"
        sortable
        :width="equipmentType == 0 ? 140 : 110"
      >
        <!-- //任务状态 任务状态:0=未开始(灰色)tag_gray,1=进行中(蓝色)tag_blue,2=已完结(绿色)tag_green,-1=已停止(红色) tag_red-->
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.is_task == '-1'
                ? 'danger'
                : scope.row.is_task == '0'
                ? 'info'
                : scope.row.is_task == '1'
                ? ''
                : 'success'
            "
          >
            <div
              class="tag_circle"
              :class="[
                scope.row.is_task == '-1'
                  ? 'tag_red'
                  : scope.row.is_task == '0'
                  ? 'tag_gray'
                  : scope.row.is_task == '1'
                  ? 'tag_blue'
                  : 'tag_green'
              ]"
            ></div>
            {{
              scope.row.is_task == "-1"
                ? "已停止"
                : scope.row.is_task == "0"
                ? "未开始"
                : scope.row.is_task == "1"
                ? "进行中"
                : "已完结"
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        property="write_type"
        label="日周结"
        align="center"
        sortable
        :width="equipmentType == 0 ? 140 : 90"
      >
        <!-- 日周接状态 1-日结 2-周结11 -->
        <template slot-scope="scope">
          <el-tag :class="scope.row.write_type == '1' ? 'day' : 'week'">
            {{ scope.row.write_type == "1" ? "日结" : "周结" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        property="createtime"
        label="创建时间"
        align="center"
        sortable
        width="250"
      >
      </el-table-column>

      <el-table-column
        :fixed="equipmentType == 1 ? false : 'right'"
        label="操作"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <div class="book_info_btn">
            <el-upload
              class="upload-demo"
              :action="uploadUrl"
              multiple
              :on-success="uploadFile"
              :show-file-list="false"
              :disabled="closeUpload"
            >
              <div
                :class="[
                  {
                    info_upload_btn: scope.row.is_task == 1,
                    disabled_btn:
                      scope.row.is_task == -1 || scope.row.is_task == 2
                  }
                ]"
                @click="upload(scope.row)"
              >
                <i class="iconfont icon-shangchuan"></i>
                <span>上传文件</span>
              </div>
            </el-upload>
            <div @click="bookInfoEdit(scope.row)" class="edit_btn">
              <i class="el-icon-edit-outline"></i>
              <span>修改</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 书籍信息修改弹窗 -->
    <el-dialog
      title="写手书籍信息修改"
      :visible.sync="editDialog"
      :width="dialogWidth"
      center
    >
      <el-form :model="editInfoForm" :rules="rules">
        <el-form-item label="给写手的千字价格:">
          <el-input v-model="editInfoForm.writer_cost"></el-input>
        </el-form-item>
        <el-form-item label="任务状态:">
          <el-radio-group v-model="editInfoForm.is_task">
            <el-radio :label="1">进行中</el-radio>
            <el-radio :label="-1">停止合作</el-radio>
            <el-radio :label="2">已完结</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="选择写手:" prop="nickname">
          <div id="mobile_select">
            <el-select
              v-model="editInfoForm.nickname"
              placeholder="请选择"
              filterable
              :popper-append-to-body="false"
              @change="selectWriter($event)"
            >
              <el-option
                v-for="item in writerList"
                :key="item.id"
                :label="item.nickname"
                :value="{
                  id: item.id,
                  writer_expand_id: item.writer_expand_id,
                  nickname: item.nickname
                }"
              ></el-option>
            </el-select>
          </div>
        </el-form-item>
        <el-form-item label="日周结:">
          <el-radio-group v-model="editInfoForm.write_type">
            <el-radio :label="1">日结</el-radio>
            <el-radio :label="2">周结</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="submitEdit"
          >确认修改</el-button
        >
        <el-button class="dialog_btn" round @click="editDialog = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>

    <el-pagination
      class="pagination_box"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>
<script>
import {
  connectionessay_list,
  cease_cooperate,
  write_operate,
  file_operate,
  edit_connectionessay,
  writer_tabulation
} from "@/utils/writer";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl, //文件上传路径
      writerId: "", //所属写手部id
      bookList: [], //书籍信息
      writerList: [], //选择写手
      isFilterForm: true, //筛选表单
      tagDialogVisible: false, //标签弹窗
      editDialog: false, //修改弹窗
      // tableWidth: "200", //表格的宽度
      dialogWidth: "30%", //弹窗宽度
      // btn_txt: true, //按钮的文字显示
      selectBookInfo: [], //选中的书籍信息
      dataShow: [], // 当前页要显示的数据,//显示的金主列表数据
      totalPageData: [], // 分页数据(全部数据已经分好页)
      pageNum: 1, // 共几页
      pageSize: 100, // 每页显示数量
      currentPage: 1, // 当前显示页码
      total: 1, // 总共多少条数据
      selectIds: "", //多选的id
      // 筛选
      filter_form: {
        operator_name: "", //金主编辑
        connectionessay_name: "", //书名
        writer_nickname: "", //写手昵称
        is_task: "", //任务状态:1=进行中,2=已完结,-1=已停止 默认空
        write_type: "", //日周接 写手结算类型:1=日结,2=周结 默认空
        createtime: "" //创建时间范围
      },
      currentUploadId: "", //文件上传id
      editInfoForm: {
        departmentuser_id: "", //所属写手部id
        connectionessay_id: "", //书籍id
        nickname: "", //写手昵称
        writer_id: "", //负责写手id
        writer_expand_id: "", //写手扩展id
        is_task: "", //任务状态1=进行中,2=已完结,-1=已停止
        writer_cost: "", //价格
        write_type: "" //日周结
      },
      rules: {
        nickname: { required: true, trigger: "blur", message: "写手不能为空" }
      },
      closeUpload: true, //上传按钮关闭
      select_time_data: "",
      time_filter: "", //时间筛选
      equipmentType: 0 //判断移动端还是pc端  0：pc  1：移动
    };
  },

  created() {
    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
    if (this.$isMobile.isDeviceType()) {
      this.equipmentType = 1;
      this.dialogWidth = "90%";
    } else {
      this.equipmentType = 0;
      this.dialogWidth = "30%";
    }
    this.getBookList();
  },

  methods: {
    // 获取书籍信息列表
    getBookList() {
      var that = this;
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10
      };
      connectionessay_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.bookList = res.data.data;
          that.calcPageData();
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 获取文件上传的id
    upload(val) {
      var that = this;
      if (val.is_task == -1 || val.is_task == 2) {
        that.closeUpload = true;
        return false;
      } else {
        that.currentUploadId = val.id;
        that.closeUpload = false;
      }
    },
    // 文件上传
    uploadFile(val) {
      var that = this;
      if (that.closeUpload == false) {
        let obj = {
          departmentuser_id: that.writerId,
          connectionessay_id: that.currentUploadId,
          file: val.data.url
        };
        file_operate(obj).then(res => {
          if (res.data.code == 1) {
            that.goSearch();
            that.$message.success(res.data.msg);
          } else {
            that.$message.error(res.data.msg);
          }
        });
      } else {
        return false;
      }
    },

    // 修改弹窗
    bookInfoEdit(val) {
      var that = this;
      that.editDialog = true;
      that.editInfoForm.nickname = val.writer_nickname;
      that.editInfoForm.writer_cost = val.writer_cost;
      that.editInfoForm.departmentuser_id = that.writerId;
      that.editInfoForm.is_task = val.is_task;
      that.editInfoForm.connectionessay_id = val.id;
      that.editInfoForm.writer_id = val.writer_id;
      that.editInfoForm.writer_expand_id = val.writer_expand_id;
      that.editInfoForm.write_type = val.write_type;
      let obj = {
        departmentuser_id: that.writerId
      };
      writer_tabulation(obj).then(res => {
        if (res.data.code == 1) {
          that.writerList = res.data.data;
        }
      });
    },
    //选择写手
    selectWriter(val) {
      var that = this;
      console.log(val);
      that.editInfoForm.writer_id = val.id;
      that.editInfoForm.writer_expand_id = val.writer_expand_id;
      that.editInfoForm.nickname = val.nickname;
      console.log(that.editInfoForm);
    },
    // 确认修改书籍信息
    submitEdit() {
      var that = this;
      let obj = {
        ...that.editInfoForm
      };
      edit_connectionessay(obj).then(res => {
        if (res.data.code == 1) {
          that.goSearch();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
        that.editDialog = false;
      });
    },

    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    },
    // 筛选
    goSearch(val) {
      var that = this;
      var date1, date2;

      that.select_time_data = that.filter_form.createtime;
      date1 = that.select_time_data[0];
      date2 = that.select_time_data[1];
      if (val == 0) {
        var time1, time2;
        time1 = that.select_time_data[0];
        time2 = that.select_time_data[1];
        that.time_filter = time1 + " - " + time2;
        that.filter_form.createtime = that.time_filter;
        console.log("刷新", that.select_time_data);
      } else {
        console.log("第一次进入页面");
        if (date1 == undefined && date2 == undefined) {
          that.time_filter = "";
        } else {
          that.time_filter = date1 + " - " + date2;
        }
        console.log("that.time_filter", that.time_filter);
        that.filter_form.createtime = that.time_filter;
      }
      let obj = {
        departmentuser_id: that.writerId,
        page: 1,
        page_index: 10,
        ...that.filter_form
      };
      connectionessay_list(obj).then(res => {
        if (res.data.code == 1) {
          that.total = res.data.data.length;
          that.bookList = res.data.data;
          that.calcPageData();
          that.filter_form.createtime = that.select_time_data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 录入金主信息
    goOwnerInfo() {
      var that = this;
      that.$router.push("/writerInfo");
    },
    // 停止合作
    ceaseCooperate() {
      var that = this;
      if (that.selectIds.length == 0) {
        return false;
      }
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_ids: that.selectIds
      };
      cease_cooperate(obj).then(res => {
        if (res.data.code == 1) {
          that.goSearch();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 转周结
    weekOperate() {
      var that = this;
      if (that.selectIds.length == 0) {
        return false;
      }
      let obj = {
        departmentuser_id: that.writerId,
        connectionessay_ids: that.selectIds
      };
      write_operate(obj).then(res => {
        if (res.data.code == 1) {
          that.goSearch();
          that.$message.success(res.data.msg);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 多选
    handleSelectionChange(val) {
      var that = this;
      that.selectBookInfo = val;
      var that = this;
      var select_arr = [];
      val.forEach(element => {
        select_arr.push(element.id);
      });
      that.selectIds = select_arr.join(",");
    },
    // 计算页数的方法
    calcPageData() {
      if (this.bookList.length > 1) {
        this.pageNum = Math.ceil(this.bookList.length / this.pageSize) || 1;
      }
      for (let i = 0; i < this.pageNum; i++) {
        this.totalPageData[i] = this.bookList.slice(
          this.pageSize * i,
          this.pageSize * (i + 1)
        );
      }
      this.dataShow = this.totalPageData[this.currentPage - 1];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.calcPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.dataShow = this.totalPageData[val - 1];
    }
  }
};
</script>
<style scoped>
.el-input__inner {
  background-color: RGB(250, 250, 250);
}

.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}
.owner_title {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
  border: 1px solid #e4e9f1;
}
/* 筛选表单 */
.filter_form {
  background: #ffffff;
  margin: 0px 15px;
  padding: 15px;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 10px 15px;
}
.addInfo,
.filtrate i {
  font-size: 14px;
}
.filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}
.book_btn_box {
  display: flex;
  flex-direction: row;
}
.book_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-right: 15px;
}
.book_btn i {
  font-size: 12px;
}
.table_box {
  margin: 0px 15px;
}
.el-tag {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 20px;
  border-radius: 10px;
  margin-left: 15px;
}

.tag_circle {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #e2170f;
  margin-right: 5px;
}

.info_upload_btn {
  width: 90px;
  text-align: center;
  height: 20px;
  line-height: 20px;
  background: #157df8;
  border-radius: 10px 10px 10px 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  margin-right: 5px;
}
.info_upload_btn i {
  font-size: 12px;
}
.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.el-dialog__header {
  background: #157df8;
}
.el-dialog__title {
  color: #fff;
}

.el-dialog--center .el-dialog__body {
  padding: 25px 70px 30px;
}
.dialog-footer .dialog_btn {
  width: 200px;
  height: 35px;
}
.checkbox {
  display: flex;
  flex-direction: column;
}
.tag_red {
  background: #f56c6c;
}
.tag_blue {
  background: #409eff;
}
.tag_green {
  background: #67c23a;
}
.tag_gray {
  background: #909399;
}
.book_info_btn {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.edit_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
}
.week {
  background: #f9f1fc;
  color: #af50d7;
  border: none;
}
.day {
  background: #e3f9e9;
  color: #67c23a;
  border: none;
}
.disabled_btn {
  cursor: not-allowed;
  width: 90px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #eeeeee;
  color: #8893a7;
  border-radius: 10px;
  margin-right: 5px;
  font-size: 12px;
  /* pointer-events: none; */
}
.disabled_btn i {
  font-size: 12px;
}
#mobile_select >>> .el-select-dropdown {
  position: absolute !important;
  top: 30px !important;
  left: 0px !important;
}
@media screen and (max-width: 750px) and (min-width: 375px) {
  .disabled_btn {
    width: 50px;
  }
  .dialog-footer .dialog_btn {
    width: 100px;
  }
  .pagination_box {
    margin-bottom: 150px;
  }
  /* 方法一 */
  /* .writer_book_info .el-select-dropdown {
    position: absolute !important;
    top: 30px !important;
    left: 0px !important;
  } */
}
</style>



// WEBPACK FOOTER //
// src/view/writer/WriterBookInfo.vue